module.exports = __webpack_public_path__ + "static/media/automa.2e7abe09.png";